const overview = [
  {
    title: "Technologies",
    paragraphs: [
      "These are the tools/skills that I honed over the years. My learning methodology is built upon a combination of tutorials and reading the necessary documentation, after which I can apply the knowledge by doing projects independently, progressively increasing the complexity. It's important to have an open mind to learning new things in a constantly changing and developing environment, where colaboration, communication, and organization is key. These are the values I stand by.",
    ],
    icons: [
      "html",
      "css",
      "javascript",
      "sass",
      "react",
      "vue",
      "git gitLight",
      "tailwind tailwindLight",
      "storybook storybookLight",
      "storyblok storyblokLight"
    ],
  },
  {
    title: "About",
    paragraphs: [
      "My name is Edin. At 22, I'm a seasoned front-end developer from Bosnia and Herzegovina with 3+ years of experience. I enjoy diving into diverse projects, being presented with unique tasks, and being confronted with challenges. I like creating with the skills I've honed, while also embracing new technologies as they come, depending on the needs of a project.",
      "I'm someone who is driven and has a reliable approach when it comes to any task or situation I undertake. I have a keen interest in designing visually appealing and functional websites and applications. Additionally, I am adaptable, cooperative, and work well in any team environment.",
      "Besides some simple things in life, like waking up, having breakfast, socializing, taking a shower, watching youtube, etc., I also enjoy participating in activities like going for a hike, hitting the gym, grilling, occasional travel, and pc enthusiasm.",
    ],
    icons: ["travel", "exercise", "grilling", "hiking", "desktopPcs"],
  },
];

export { overview };
